import { startOfDay, subDays } from 'date-fns';

// Shipment data is only offered for the previous 100 days across the console (Shipment Search,
// Shipment Volume, Datalake Export). The Historical Shipium Dataset reads the same carrier
// selections and the backend does not enforce a floor, so the picker has to hold the line.
export const HISTORICAL_DATASET_LOOKBACK_DAYS = 100;

export const HISTORICAL_DATASET_LOOKBACK_MESSAGE = `Shipment data is only available for the previous ${HISTORICAL_DATASET_LOOKBACK_DAYS} days`;

export const getEarliestHistoricalDatasetDate = (now: Date = new Date()): Date =>
  startOfDay(subDays(now, HISTORICAL_DATASET_LOOKBACK_DAYS));

export const isBeforeHistoricalDatasetLookback = (current: Date, now: Date = new Date()): boolean =>
  current < getEarliestHistoricalDatasetDate(now);

// Form rule for the date range. disabledDate only guards the calendar; this also catches a range
// restored from a saved simulation that has since aged out of the window.
export const historicalDatasetLookbackValidator =
  (now?: Date) =>
  async (_rule: unknown, value?: [Date | null, Date | null] | null): Promise<void> => {
    const start = value?.[0];
    if (start && isBeforeHistoricalDatasetLookback(start, now ?? new Date())) {
      throw new Error(HISTORICAL_DATASET_LOOKBACK_MESSAGE);
    }
  };
